document.addEventListener('DOMContentLoaded', function() {

  // ===== VARIANT SELECTION =====
  var ldVariants = [];
  var ldSelected = {};

  var variantDataEl = document.getElementById('ld-variant-data');
  if (variantDataEl) {
    try { ldVariants = JSON.parse(variantDataEl.textContent); } catch(e) {}
  }

  window.ldO = function(el, optName, val, idx) {
    // Remove active from siblings
    var parent = el.parentNode;
    if (parent) {
      var siblings = parent.querySelectorAll('.ld-opt, .ld-swatch');
      siblings.forEach(function(s) { s.classList.remove('on'); });
    }
    el.classList.add('on');

    // Update label
    ldSelected[optName] = val;
    var lbl = document.getElementById('ld-ov-' + idx);
    if (lbl) lbl.textContent = val;

    // Match variant
    var match = ldVariants.find(function(v) {
      return v.options.every(function(o, i) {
        var keys = Object.keys(ldSelected);
        return keys[i] ? ldSelected[keys[i]] === o : true;
      });
    });

    if (match) {
      var vidEl = document.getElementById('ld-vid');
      var priceEl = document.getElementById('ld-price');
      if (vidEl) vidEl.value = match.id;
      if (priceEl) priceEl.textContent = Math.round(match.price / 100);
    }
  };

  // Init selected state from active buttons
  document.querySelectorAll('.ld-opt.on, .ld-swatch.on').forEach(function(el) {
    var opt = el.dataset.opt;
    var val = el.dataset.val;
    if (opt && val) ldSelected[opt] = val;
  });

  // ===== THUMBNAIL SWAP =====
  document.querySelectorAll('.ld-thumb').forEach(function(t) {
    t.addEventListener('click', function() {
      document.querySelectorAll('.ld-thumb').forEach(function(x) { x.classList.remove('on'); });
      this.classList.add('on');
      var mi = document.getElementById('ld-main-img');
      if (mi && this.dataset.src) mi.src = this.dataset.src;
    });
  });

  // ===== TABS =====
  document.querySelectorAll('.ld-tab').forEach(function(b) {
    b.addEventListener('click', function() {
      var panel = this.dataset.panel;
      document.querySelectorAll('.ld-tab').forEach(function(x) { x.classList.remove('on'); });
      document.querySelectorAll('.ld-panel').forEach(function(x) { x.classList.remove('on'); });
      this.classList.add('on');
      var el = document.getElementById('ldp-' + panel);
      if (el) el.classList.add('on');
    });
  });

  // ===== QTY CONTROLS =====
  document.querySelectorAll('[data-ld-minus]').forEach(function(b) {
    b.addEventListener('click', function() {
      var w = this.closest('[data-ld-qty]');
      if (!w) return;
      var v = w.querySelector('[data-ld-val]');
      var i = w.querySelector('input[name=quantity]');
      var n = parseInt(v ? v.textContent : 1) || 1;
      if (n > 1) { n--; if (v) v.textContent = n; if (i) i.value = n; }
    });
  });

  document.querySelectorAll('[data-ld-plus]').forEach(function(b) {
    b.addEventListener('click', function() {
      var w = this.closest('[data-ld-qty]');
      if (!w) return;
      var v = w.querySelector('[data-ld-val]');
      var i = w.querySelector('input[name=quantity]');
      var n = parseInt(v ? v.textContent : 1) || 1;
      n++; if (v) v.textContent = n; if (i) i.value = n;
    });
  });

  // ===== SCROLL ANIMATIONS =====
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.ld-col-card, .ld-cat-pill, .ld-story__feat, .ld-rev, .ld-rel-card').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity .4s ease, transform .4s ease';
      obs.observe(el);
    });
  }

});

/* Product media retry/fallback — 2026-08 */
(function(){
  function cleanShopifyUrl(src){
    try{
      var u=new URL(src,location.href);
      ['width','height','crop'].forEach(function(k){u.searchParams.delete(k);});
      return u.href;
    }catch(e){return src;}
  }
  function bindProductImage(img){
    if(!img || img.dataset.ldMediaBound || img.id==='ldp-hero') return;
    if(!img.closest('.ldp,.ldst,.ldr,product-recommendations')) return;
    img.dataset.ldMediaBound='1';
    img.addEventListener('error',function(){
      if(!img.dataset.ldRetried){
        img.dataset.ldRetried='1';
        var retry=cleanShopifyUrl(img.currentSrc||img.src);
        if(retry && retry!==(img.currentSrc||img.src)){img.src=retry;return;}
      }
      var box=img.parentElement;
      img.style.display='none';
      if(box) box.classList.add('ld-media-unavailable');
    });
    if(img.complete && img.naturalWidth===0) img.dispatchEvent(new Event('error'));
  }
  function scan(root){(root||document).querySelectorAll('img').forEach(bindProductImage);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){scan(document);});
  else scan(document);
  new MutationObserver(function(ms){ms.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1){if(n.tagName==='IMG')bindProductImage(n);scan(n);}});});})
    .observe(document.documentElement,{childList:true,subtree:true});
})();
